import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CompassesFrameworks extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'CompassesFrameworks'
  // Define default properties here
  static instanceDefaults () {
    return {
      compassId: null,
      frameworkId: null,
      isDefault: true,
    }
  }
}
const servicePath = 'compasses-frameworks'
const servicePlugin = makeServicePlugin({
  Model: CompassesFrameworks,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
